import styled from 'styled-components';
import InputMask from 'react-input-mask';

//Principais divs

export const ContainerConta = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
`;

export const BoxConta = styled.div`
    display:flex;
    justify-content:center;
    margin-bottom:30px;
`;

export const BoxCadastro = styled.div`
    display:inline-block;
    justify-content:center;
    padding: 0px 20px 0px 20px;
`;

export const BoxLogin = styled.div`
    display:inline-block;
    justify-content:center;
`;

export const BoxGoogle = styled.div`
    display: inline-flex;
    padding: 15px 37px;
    align-items: flex-start;
    gap: 30px;
    border-radius: 10px;
    border: 1px solid #D2D2D2;
    cursor:pointer;
`;

export const InputConta = styled.input`
    height: 44px;
    align-self: stretch;
    border-radius: 8px;
    border: 1px solid #D2D2D2;
    outline:none;
    width: 97%;
    padding: 0px 10px 0px 10px;
    // padding-left:10px;
    // padding-right:10px;
`;
export const InputMascara = styled(InputMask)`
    height: 44px;
    align-self: stretch;
    border-radius: 8px;
    border: 1px solid #D2D2D2;
    outline:none;
    width: 97%;
    padding: 0px 10px 0px 10px;
    // padding-left:10px;
    // padding-right:10px;
`;



export const ButtonConta = styled.div`
    display: flex;
    height: 48px;
    padding: 0px 32px;
    justify-content: center;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
    border-radius: 8px;
    background: #000;
    cursor:pointer;

`;

export const FlexConta = styled.div`
    display:flex;
    gap:4px;
    justify-content: center;
    align-items: center;
    margin-top:25px;
     width: 100%;
    
`;

export const ContainerInputsConta = styled.div`
    margin-bottom:30px;
    display: flex;
    flex-direction:column;
    gap:15px;
`;

export const BoxInputs = styled.div`
    display: inline-block;
`;

//Textos principais

export const P1 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin:0;
`;

export const P2 = styled.p`
    color: #000;
    text-align: center;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin:0;
`;

export const P3 = styled.p`
    color: #000;
    font-family: Outfit;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin:0;
`;

export const P4 = styled.p`
    color: #FFF;
    text-align: center;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin:0;
`;

export const P5 = styled.p`
    color: var(--Cinza-2, #848484);
    text-align: center;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin:0;
`;

export const P6 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin:0;
`;

export const P7 = styled.p`
    color: #848484;
    text-align: center;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export const P8 = styled.p`
    color: #848484;
    text-align: center;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-decoration-line: underline;
    cursor:pointer;
`;

// Divs estilizadas

export const DividerContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 20px 0;
    position: relative;
`;

export const DividerLine = styled.div`
    border-top: 1px solid #848484;
    width: 100%;
    position: absolute;
    top: 50%;
    opacity: 0.2;
`;

export const DividerText = styled.div`
    background: white;
    padding: 0 10px;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-weight: 600;
    position: relative;
    z-index: 0;
`;